import { Component, Output, EventEmitter, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToasterService } from '../../../../services/toaster/toaster.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './change-password.html',
})
export class ChangePassword {
  private toaster = inject(ToasterService);

  @Output() cancel = new EventEmitter<void>();

  currentPassword = signal('');
  newPassword = signal('');
  confirmPassword = signal('');

  onSubmit() {
    if (!this.currentPassword() || !this.newPassword() || !this.confirmPassword()) {
      this.toaster.warning('Please fill in all fields.');
      return;
    }

    if (this.newPassword() !== this.confirmPassword()) {
      this.toaster.warning('New password and confirm password do not match.');
      return;
    }

    // Mock successful update
    this.toaster.success('Password changed successfully!');
    this.cancel.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
